import { PageStatusData } from "../../PageStatusData";
import { ServiceResponse } from "../ServiceResponse";

export class PageStatusResponse extends ServiceResponse {
  public GlobalPageStatus: PageStatusData | null = null;
  public PageStatus: PageStatusData | null = null;
}
